<div class="layout-topbar shadow-4">
  <div id="layout-topbar" class="layout-topbar-left">
    <a class="layout-topbar-logo" routerLink="/">
      <img id="app-logo" [src]="app.appearance.logo"
           alt="wtg watch this garage logo"
           height="56" width="100">
    </a>

    <a *ngIf="appMain.isLoggedIn" class="layout-menu-button shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple
       data-tutorial="tutorial-topbar-menu">
      <i class="pi pi-chevron-right"></i>
    </a>

    <div class="layout-topbar-mobile-actions"
         *ngIf="appMain.isLoggedIn"
         [class.layout-topbar-mobile-actions--hidden]="appMain.mobileTopbarActive && appMain.activeTopbarItem !== 'notifications'">
      <a class="layout-topbar-action rounded-circle"
         (click)="$event.stopPropagation(); handleMobileNotificationClick($event)"
         pRipple
         data-tutorial="tutorial-topbar-notifications-mobile">
        <span class="p-overlay-badge">
          <i *ngIf="!newNotificationsCount" class="pi pi-bell fs-large"></i>
          <i *ngIf="newNotificationsCount" class="pi pi-bell fs-large" pBadge
             [value]="newNotificationsCount" badgeSize="large"></i>
        </span>
      </a>
    </div>

    <a class="layout-topbar-mobile-button" [class.layout-topbar-mobile-button--guest]="!appMain.isLoggedIn"
       (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
      <i class="pi pi-ellipsis-v fs-large"></i>
    </a>
  </div>

  <div class="layout-topbar-right"
       [ngClass]="{
         'layout-topbar-mobile-active': appMain.mobileTopbarActive,
         'layout-topbar-mobile-notifications': appMain.mobileTopbarActive && appMain.activeTopbarItem === 'notifications'
       }">
    <div #navigationSlot class="layout-topbar-actions-left topbar-navigation">
      <p-megaMenu
        #fullNavigation
        class="topbar-navigation__full"
        [class.topbar-navigation__full--measuring]="compactNavigation"
        [class.topbar-navigation__full--icons]="showNavigationIcons"
        [attr.aria-hidden]="desktopNavigation && compactNavigation ? 'true' : null"
        [attr.inert]="desktopNavigation && compactNavigation ? '' : null"
        [model]="model"
        styleClass="layout-megamenu"
      ></p-megaMenu>
      <p-megaMenu
        #compactMenu
        class="topbar-navigation__compact"
        [class.topbar-navigation__compact--active]="compactNavigation"
        [model]="compactNavigationModel"
        [ariaLabel]="'shared.top_bar.menu.navigation' | translate"
        styleClass="layout-megamenu layout-megamenu--compact"
      ></p-megaMenu>
    </div>
    <div class="layout-topbar-actions-right" [ngClass]="{'public-actions': !appMain.isLoggedIn}">
      <ul class="layout-topbar-items">
        <li class="layout-topbar-item layout-search-item" *ngIf="appMain.isLoggedIn">
          <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'search')" pRipple
             data-tutorial="tutorial-topbar-search">
            <i class="pi pi-search fs-large"></i>
          </a>

          <div class="layout-search-panel p-inputgroup" style="flex-wrap: wrap"
               [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.search"
               (@topbarActionPanelAnimation.done)="onSearchAnimationEnd($event)">
            <span class="p-inputgroup-addon"><i class="pi pi-search" (click)="goToSearchResults()"></i></span>
            <input
              #searchInput
              type="text"
              pInputText
              [placeholder]="'shared.top_bar.placeholder.search' | translate"
              (click)="appMain.searchClick = true"
              (keydown)="appMain.onSearchKeydown($event)"
              [(ngModel)]="query"
              (ngModelChange)="appMain.emitQuery($event)"
              (keyup.enter)="goToSearchResults()"
            >
            <span class="p-inputgroup-addon">
                            <button pButton pRipple type="button" icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-plain"
                                    (click)="appMain.searchClick = false; appMain.searchMenuClick = false; appMain.onTopbarMobileButtonClick($event)"></button>
                        </span>
            <div class="w-full flex justify-content-center">
              <app-search-list [phrase]="query" [user]="user" (click)="appMain.searchMenuClick = true;"></app-search-list>
            </div>
          </div>
        </li>
        <li class="layout-topbar-item notifications" *ngIf="appMain.isLoggedIn">
          <a class="layout-topbar-action rounded-circle" (click)="handleNotificationItemClick($event)" pRipple
             data-tutorial="tutorial-topbar-notifications-desktop">
                        <span class="p-overlay-badge">
                            <i *ngIf="!newNotificationsCount" class="pi pi-bell fs-large"></i>
                            <i *ngIf="newNotificationsCount" class="pi pi-bell fs-large" pBadge
                               [value]="newNotificationsCount" badgeSize="large"></i>
                        </span>
          </a>

          <ul class="layout-topbar-action-panel layout-topbar-notification-panel shadow-6"
              #notificationsPanel
              [class.notification-panel--loading]="initialNotificationsLoading && !displayedNotifications.length"
              (scroll)="onNotificationsScroll($event)"
              [style.paddingTop.px]="displayedNotifications.length ? 0 : 14"
              [@topbarActionPanelAnimation]="'visible'"
              *ngIf="appMain.activeTopbarItem === 'notifications'">
            <li *ngIf="newNotifications.length" class="mb-3 flex justify-content-center align-items-center">
              <span class="px-3 fs-small"
                    [innerHTML]="'shared.top_bar.notifications.new_notifications' | translate: {newNotificationsCount}"></span>
            </li>
            <li *ngIf="!initialNotificationsLoading && !displayedNotifications.length" class="flex flex-column justify-content-center align-items-center">
              <span class="px-3 fs-small">{{ 'shared.top_bar.notifications.no_new_notifications' | translate }}</span>
            </li>
            <li *ngFor="let notification of displayedNotificationItems" class="layout-topbar-action-item"
                [class.notification-placeholder-row]="notification['isPlaceholder']">
              <ng-container *ngIf="!notification['isPlaceholder']; else notificationPlaceholder">
              <app-notification-item
                [notification]="notification"
                variant="panel"
                (interacted)="onNotificationItemInteracted($event)"
                (resolved)="removeResolvedNotification($event)"
              ></app-notification-item>
              <div *ngIf="false" class="flex flex-row align-items-center p-2">
                <app-thumbnail
                  classList="thumbnail-inline-block"
                  size="md"
                  [circle]="true"
                  [imgSrc]="getNotificationThumbnail(notification) | mediaObject: getNotificationThumbnailOptions(notification)"
                ></app-thumbnail>
                <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}"
                     style="flex-grow: 1;">
                  <div class="flex justify-content-between mb-2">
                    <a class="p-0 w-auto" (click)="navigateToUserProfile($event, notification)"><span
                      class="fs-small font-bold">{{ notification.fromUser.username }}</span></a>
                    <small>{{ notification.createdAt | dateAgo }}</small>
                  </div>
                  <span class="fs-small">
                    <ng-container [ngSwitch]="notification['type']">
                      <ng-container *ngSwitchCase="'PROJECT'">
                        <ng-container [ngSwitch]="notification['event']">
                          <ng-container *ngSwitchCase="'chat_project_mention'">
                            {{ 'shared.top_bar.notifications.mentioned_project_in_chat' | translate }}
                            <a class="p-0 font-bold" (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                            {{ 'shared.top_bar.notifications.in_chat_on' | translate }}
                            <a class="p-0 font-bold" (click)="navigateToConversation($event, notification)">
                              {{ 'shared.top_bar.notifications.chat_link_label' | translate }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'collaboration_created'">
                            {{ 'shared.top_bar.notifications.collaboration_created' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToCollaboration($event, notification)">
                              {{ notification.context['collaborationTitle'] || ('#' + notification.context['collaborationId']) }}
                            </a>
                            {{ 'shared.top_bar.notifications.in_project' | translate }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'collaboration_asset_approved'">
                            {{ 'shared.top_bar.notifications.collaboration_asset_approved' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToCollaboration($event, notification)">
                              {{ notification.context['collaborationTitle'] || ('#' + notification.context['collaborationId']) }}
                            </a>
                            {{ 'shared.top_bar.notifications.in_project' | translate }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'collaboration_asset_rejected'">
                            {{ 'shared.top_bar.notifications.collaboration_asset_rejected' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToCollaboration($event, notification)">
                              {{ notification.context['collaborationTitle'] || ('#' + notification.context['collaborationId']) }}
                            </a>
                            {{ 'shared.top_bar.notifications.in_project' | translate }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'instagram_sync_completed'">
                            {{ 'shared.top_bar.notifications.instagram_sync_completed' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                            {{ 'shared.top_bar.notifications.instagram_sync_completed_guide' | translate }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'instagram_sync_failed'">
                            {{ 'shared.top_bar.notifications.instagram_sync_failed' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                            <div *ngIf="notification.context?.['errorMessage']" class="mt-1 fs-small">
                              {{ notification.context['errorMessage'] }}
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            {{ 'shared.top_bar.notifications.follow_project' | translate }}
                            <a class="p-0 font-bold" (click)="navigateToProject($event, notification)">
                              {{ getNotificationProjectLabel(notification) }}
                            </a>
                            {{ 'shared.top_bar.notifications.from_your_garage'|translate }}
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'OWNER'">
                        <ng-container [ngSwitch]="notification['event']">
                          <ng-container *ngSwitchCase="'project_owner_invitation'">
                            {{ 'shared.top_bar.notifications.owner_invitation' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">{{ notification.context['project'] }}</a>
                            <div *ngIf="notification['subject'] && !notification['subject']['acceptedAt'] && !notification['subject']['deniedAt']"
                                 class="mt-2 flex gap-2">
                              <button pButton (click)="navigateToInvitationPage($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'primary'"
                                      [size]="'small'">{{ 'common.confirm' | translate }}</button>
                              <button pButton (click)="denyOwnerInvitation($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'secondary'"
                                      [size]="'small'">{{ 'common.reject' | translate }}</button>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'project_main_owner_change_invitation'">
                            {{ 'shared.top_bar.notifications.main_owner_change' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">{{ notification.context['project'] }}</a>
                            <div *ngIf="notification['subject'] && !notification['subject']['acceptedAt'] && !notification['subject']['deniedAt']"
                                 class="mt-2 flex gap-2">
                              <button pButton (click)="navigateToChangeOwnerConfirmationPage($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'primary'"
                                      [size]="'small'">{{ 'common.confirm' | translate }}</button>
                              <button pButton (click)="denyOwnerInvitation($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'secondary'"
                                      [size]="'small'">{{ 'common.reject' | translate }}</button>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'project_owner_invitation_denied'">
                            {{ 'shared.top_bar.notifications.owner_invitation_denied' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToProject($event, notification)">{{ notification.context['vehicleName'] }}</a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'EVENT'">
                        <ng-container [ngSwitch]="notification['event']">
                          <ng-container *ngSwitchCase="'event_invitation'">
                            {{ 'shared.top_bar.notifications.event_invitation' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToEvent($event, notification)">{{ notification.context['event'] }}</a>
                            <div *ngIf="notification['subject'] && !notification['subject']['acceptedAt'] && !notification['subject']['deniedAt']"
                                 class="mt-2 flex gap-2">
                              <button pButton (click)="acceptEventInvitation($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'primary'"
                                      [size]="'small'">{{ 'common.confirm' | translate }}</button>
                              <button pButton (click)="denyEventInvitation($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'secondary'"
                                      [size]="'small'">{{ 'common.reject' | translate }}</button>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'event_participation_requested'">
                            {{ 'shared.top_bar.notifications.event_participation_requested' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToEvent($event, notification)">{{ notification.context['event'] }}</a>
                            <div *ngIf="notification.context?.['vehicles']?.length" class="mt-1 fs-small">
                              {{ 'shared.top_bar.notifications.event_participation_vehicles' | translate }}:
                              {{ getParticipationVehiclesLabel(notification) }}
                            </div>
                            <div *ngIf="notification['subject']?.['status'] === 'PENDING'" class="mt-2 flex gap-2">
                              <button pButton (click)="approveEventParticipationRequest($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'primary'"
                                      [size]="'small'">{{ 'common.confirm' | translate }}</button>
                              <button pButton (click)="rejectEventParticipationRequest($event, notification)"
                                      [outlined]="true" [text]="true" [severity]="'secondary'"
                                      [size]="'small'">{{ 'common.reject' | translate }}</button>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'event_participation_approved'">
                            {{ 'shared.top_bar.notifications.event_participation_approved' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToEvent($event, notification)">{{ notification.context['event'] }}</a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'event_participation_rejected'">
                            {{ 'shared.top_bar.notifications.event_participation_rejected' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToEvent($event, notification)">{{ notification.context['event'] }}</a>
                            <div *ngIf="notification.context?.['rejectionReason']" class="mt-1 fs-small">
                              {{ notification.context['rejectionReason'] }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'POST'">
                         <ng-container [ngSwitch]="notification['event']">
                          <ng-container *ngSwitchCase="'post_user_mention'">
                            {{ 'shared.top_bar.notifications.mentioned_in_post' | translate }}&nbsp;<a class="p-0 blue-color font-bold" [routerLink]="['posts', notification.subject.id]">#{{notification.subject.id}} {{notification.context['projectName']}}</a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'post_project_mention'">
                            {{ 'shared.top_bar.notifications.mentioned_project_in_post' | translate }}&nbsp;
                            <a class="p-0 blue-color font-bold" [routerLink]="['posts', notification.subject.id]">#{{notification.subject.id}} {{notification.context['projectName']}}</a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'post_processing_completed'">
                            {{ 'shared.top_bar.notifications.post_processing_completed' | translate }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'post_processing_partially_completed'">
                            {{ 'shared.top_bar.notifications.post_processing_partially_completed' | translate }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'post_processing_failed'">
                            {{ 'shared.top_bar.notifications.post_processing_failed' | translate }}
                          </ng-container>
                         </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'USER'">
                        {{ 'shared.top_bar.notifications.follow_profile' | translate }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'MARKETPLACE'">
                        <ng-container [ngSwitch]="notification['event']">
                          <ng-container *ngSwitchCase="'marketplace_saved_search_new_offer'">
                            {{ 'shared.top_bar.notifications.marketplace_saved_search_new_offer' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToMarketplaceOffer($event, notification)">{{ notification.context['advertisementTitle'] || notification.subject?.title }}</a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'marketplace_followed_offer_updated'">
                            {{ 'shared.top_bar.notifications.marketplace_followed_offer_updated' | translate: getNotificationParams(notification) }}
                            <a class="p-0 font-bold"
                               (click)="navigateToMarketplaceOffer($event, notification)">{{ notification.context['advertisementTitle'] || notification.subject?.title }}</a>
                            <div *ngIf="getMarketplaceChangedFieldsLabels(notification)" class="mt-1 fs-small">
                              {{ 'shared.top_bar.notifications.marketplace_followed_offer_updated.changed_fields' | translate }}:
                              {{ getMarketplaceChangedFieldsLabels(notification) }}
                            </div>
                            <div *ngIf="notification.context?.['locationLabel']" class="mt-1 fs-small">
                              {{ notification.context['locationLabel'] }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'MEDIA_OBJECT'">
                        {{ 'shared.top_bar.notifications.media_object_ready' | translate }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'DOCUMENT'">
                        {{ 'shared.top_bar.notifications.document_ready' | translate }}
                      </ng-container>
                    </ng-container>
                  </span>
                </div>
              </div>
              </ng-container>
            </li>
            <ng-template #notificationPlaceholder>
              <div class="notification-placeholder-item flex flex-row align-items-center p-2">
                <p-skeleton width="2.5rem" height="2.5rem" borderRadius="999px"></p-skeleton>
                <div class="flex flex-column ml-3 w-full" style="flex-grow: 1;">
                  <div class="flex justify-content-between mb-1">
                    <p-skeleton styleClass="notification-placeholder-line" width="6.2rem" height="0.9rem"></p-skeleton>
                    <p-skeleton styleClass="notification-placeholder-line" width="5.2rem" height="0.9rem"></p-skeleton>
                  </div>
                  <p-skeleton styleClass="notification-placeholder-line" width="72%" height="0.95rem"></p-skeleton>
                </div>
              </div>
            </ng-template>
            <li *ngIf="isLoadingNextNotifications && displayedNotifications.length" class="notification-panel-loader flex justify-content-center align-items-center py-2">
              <app-spinner [inline]="true" size="1.5rem"></app-spinner>
            </li>
            <li *ngIf="showEndOfNotifications" class="notification-panel-end-label flex justify-content-center align-items-center py-2">
              <span class="fs-small">{{ 'common.already_on_recent' | translate }}</span>
            </li>
            <li *ngIf="displayedNotifications.length" class="notification-panel-end-spacer" aria-hidden="true"></li>
          </ul>
        </li>
        <li class="layout-topbar-item" *ngIf="appMain.isLoggedIn">
          <a class="layout-topbar-action rounded-circle" [routerLink]="['/chat']" pRipple>
            <span class="p-overlay-badge">
              <i *ngIf="!unreadChatCount" class="pi pi-comments fs-large"></i>
              <i *ngIf="unreadChatCount" class="pi pi-comments fs-large" pBadge
                 [value]="unreadChatCount" badgeSize="large"></i>
            </span>
          </a>
        </li>
        <li class="layout-topbar-item" *ngIf="appMain.isLoggedIn">
          <a class="layout-topbar-action flex p-dir-row justify-content-center align-items-center px-2 rounded-circle"
             (click)="appMain.onTopbarItemClick($event, 'profile')" pRipple
             data-tutorial="tutorial-account-shortcuts">
            <app-thumbnail
              [imgSrc]="this.user.avatar | mediaObject" [circle]="true" [bordered]="true"
              stylesList="width: 32px; height: 32px;"
            ></app-thumbnail>
          </a>

          <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'"
              *ngIf="appMain.activeTopbarItem === 'profile'" (click)="appMain.resetActiveMenus()">
            <li class="layout-menuitem-text">
              {{ 'common.shortcuts' | translate }}
            </li>
            <li class="layout-topbar-action-item" *ngxPermissionsOnly="['ROLE_ADMIN']">
              <a [routerLink]="['/admin']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-lock" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.admin_dashboard' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'garage']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-warehouse" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.garage' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'profile']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-user" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.profile' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'settings']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-cog" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.settings' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'settings']" fragment="tutorials" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-compass" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.tutorials' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a href="#" class="flex flex-row align-items-center" pRipple (click)="startCurrentViewTutorial($event)">
                <i class="pi pi-directions" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.current_view_tutorial' | translate }}</span>
              </a>
            </li>
            <li class="layout-menuitem-text">
              {{ 'common.marketplace' | translate }}
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'offers']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-gauge" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.my_advertisements' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'saved-offers']" class="flex flex-row align-items-center" pRipple>
                <i class="pi pi-heart" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.followed_advertisements' | translate }}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/', user.slug, 'saved-search-results']" class="flex flex-row align-items-center"
                 pRipple>
                <i class="pi pi-search" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'common.saved_search_results' | translate }}</span>
              </a>
            </li>
            <li class="layout-menuitem-text">
              {{ 'inspections.title' | translate }}
            </li>
            <li *ngFor="let item of inspectionNavigationItems" class="layout-topbar-action-item">
              <a [routerLink]="item.routerLink" class="flex flex-row align-items-center" pRipple>
                <i [class]="item.icon" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ item.labelKey | translate }}</span>
              </a>
            </li>
            <li>
              <hr/>
            </li>
            <li class="layout-topbar-action-item">
              <a [routerLink]="['/']" class="flex flex-row align-items-center" pRipple (click)="logout($event)">
                <i class="pi pi-power-off" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{ 'shared.inline_menu.logout' | translate }}</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="layout-topbar-item" *ngIf="!appMain.isLoggedIn">
          <button pButton type="button" class="p-button-text p-button-sm px-3"
                  [routerLink]="['/login']">
            {{ 'auth.login.button.sign_in' | translate }}
          </button>
        </li>
        <li class="layout-topbar-item px-3" *ngIf="!appMain.isLoggedIn">
          <button pButton type="button" class="p-button-sm"
                  [routerLink]="['/registration']">
            {{ 'auth.login.button.sign_up' | translate }}
          </button>
        </li>
        <li class="layout-topbar-item" *ngIf="appMain.isLoggedIn">
          <a class="layout-topbar-action rounded-circle" (click)="appMain.onRightMenuButtonClick($event)" pRipple>
            <i class="pi fs-large" [ngClass]="{'pi-arrow-left': !app.isRTL, 'pi-arrow-right': app.isRTL}"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
